import ApiBase from './ApiBase';

export const ENTITIES_ENDPOINT = 'entities';
export const ORGS_ENDPOINT = 'orgs';

export default class NavigatorService extends ApiBase {
  async fetchEntities(filters) {
    const { data } = await this.client.post(`/${ENTITIES_ENDPOINT}`, { filters });

    return data;
  }

  async fetchOrgs() {
    const { data } = await this.client.get(`/${ORGS_ENDPOINT}`);

    return data;
  }
}
